var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view'),_vm._v(" "),_c('EventBus',{on:{"onViewImages":_vm.onViewImages}}),_vm._v(" "),_c('div',{directives:[{name:"viewer",rawName:"v-viewer",value:(_vm.options),expression:"options"}],staticClass:"images"},[_vm._l((_vm.images),function(ref){
var source = ref.source;
var thumbnail = ref.thumbnail;
return [_c('img',{key:source,staticClass:"image",attrs:{"src":thumbnail,"data-source":source,"alt":source}})]})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2241f230","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 